/** Wire error codes of the leader callables, so the web app can name what went wrong. */
export enum LeaderErrorCode {
  FEATURE_DISABLED = 'leader-feature-disabled',
  LEADER_ROLE_REQUIRED = 'leader-role-required',
  TARGET_NOT_LEADER = 'leader-target-not-leader',
  SCOPE_USER_NOT_PARTICIPANT = 'leader-scope-user-not-participant',
  SCOPE_CONTAINS_LEADER = 'leader-scope-contains-leader',
  SCOPE_TOO_LARGE = 'leader-scope-too-large',
  SCOPE_INVALID = 'leader-scope-invalid'
}
